import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'formatDate',
})
@Injectable({ providedIn: 'root' })
export class FormatDatePipe implements PipeTransform {
  transform(value: any, formatType: 'request' | 'message' | 'picker' = 'request'): string {
    if (!value) return '';

    switch (formatType) {
      case 'message':
        return moment(value).format('DD/MM/YYYY @ HH:mm:ss.SSS');
      case 'picker':
        return moment(value).format('YYYY-MM-DD');
      case 'request':
      default:
        return moment(value).format('DD/MM/YYYY @ HH:mm:ss');
    }
  }
}
